import { useContext, useEffect, useState } from "react";
import { Checkbox, Col, Form, Input, Row, Select } from "antd";
import { AuthContext } from "../../../Contexts/AuthContext";
import styles from "../ShippingAddressScreen.module.scss";

export const PersonalInformation = ({
  form,
  onFinish,
  isAddrSame,
  setIsAddrSame,
}) => {
  const { user } = useContext(AuthContext);
  const [countries, setCountries] = useState([]);
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    fetch(
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/index.json",
    )
      .then((response) => response.json())
      .then((json) => setCountries(json));

    if (sessionStorage.getItem("personal")) {
      setInitialValues(JSON.parse(sessionStorage.getItem("personal")));
    } else {
      setInitialValues({
        title: user.b_title,
        phone_prefix: "49",
        country: "Germany",
        first_name: user.b_first_name,
        last_name: user.b_first_name,
        street_address: user.b_street_address,
        house_no: user.b_house_no,
        zip_code: user.b_zip_code,
        state: user.b_state,
        city: user.b_city,
        email: user.b_email,
        phone_number: user.b_phone_number,
      });
    }
  }, []);

  if (!initialValues) return null;

  return (
    <div className={styles.shipping_form}>
      <Form
        onFinish={onFinish}
        layout="vertical"
        initialValues={initialValues}
        requiredMark={false}
        scrollToFirstError
        form={form}
        className={styles.shipping_form_v2}
      >
        <Row gutter={[16, 12]}>
          <Col lg={24} xs={24}>
            <Form.Item
              name="title"
              style={{
                maxWidth: window.innerWidth > 577 ? "100%" : "45%",
                width: "200px",
              }}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder="Title"
              >
                <Select.Option value="Mr.">Mr.</Select.Option>
                <Select.Option value="Mrs.">Mrs.</Select.Option>
                <Select.Option value="Ms.">Ms.</Select.Option>
                <Select.Option value="Miss.">Miss</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col lg={12} xs={12}>
            <Form.Item
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Please input your first name!",
                },
              ]}
            >
              <Input placeholder="First Name*" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={12}>
            <Form.Item
              name="last_name"
              rules={[
                {
                  required: true,
                  message: "Please input your last name!",
                },
              ]}
            >
              <Input placeholder="Last name*" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={24}>
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid email!",
                },
                {
                  required: true,
                  message: "Please input your email!",
                },
              ]}
            >
              <Input placeholder="Email address*" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={24}>
            <Form.Item name="phone_number">
              <Input
                placeholder="Phone (Optional)"
                addonBefore={
                  <Form.Item name="phone_prefix" noStyle>
                    <Select
                      style={{
                        width: 70,
                      }}
                    >
                      <Select.Option value="49">+49</Select.Option>
                    </Select>
                  </Form.Item>
                }
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Col>
          <Col lg={24} xs={24}>
            <Form.Item
              name="street_address"
              rules={[
                {
                  required: true,
                  message: "Please input your street address!",
                },
              ]}
            >
              <Input placeholder="Street Address*" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={12}>
            <Form.Item
              name="house_no"
              rules={[
                {
                  required: true,
                  message: "Please input your house nr!",
                },
              ]}
            >
              <Input placeholder="House Nr*" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={12}>
            <Form.Item
              name="zip_code"
              rules={[
                {
                  required: true,
                  message: "Please input your zip code",
                },
              ]}
            >
              <Input placeholder="Zip / Postal Code*" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={12}>
            <Form.Item
              name="city"
              rules={[
                {
                  required: true,
                  message: "Please input your city name!",
                },
              ]}
            >
              <Input placeholder="City / Town *" />
            </Form.Item>
          </Col>
          <Col lg={12} xs={12}>
            <Form.Item
              name="state"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input placeholder="State / Region" />
            </Form.Item>
          </Col>

          <Col lg={12} xs={12}>
            <Form.Item
              name="country"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select disabled placeholder="Country">
                {countries.map((country, index) => (
                  <Select.Option value={country.name} key={String(index)}>
                    <div className={"d-flex align-items-center gap-2"}>
                      <img width={"20px"} src={country.image} alt="" />
                      {country.name}
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Checkbox
              defaultChecked={isAddrSame}
              value={isAddrSame}
              onChange={() => setIsAddrSame(!isAddrSame)}
            >
              Shipping address is same as Personal/Billing information
            </Checkbox>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
